import React from "react";
import "../css/Inicio.css"

function Inicio() {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        height: "80vh",
        background: "linear-gradient(to right, #f8f9fa, #e9ecef)",
      }}
    >
      <div
        className="card shadow-lg text-center p-5"
        style={{
          borderRadius: "20px",
          maxWidth: "700px",
          width: "100%",
          animation: "fadeIn 0.8s ease-out",
        }}
      >
        <img
          // src="https://static.vecteezy.com/system/resources/thumbnails/036/105/045/small_2x/artificial-intelligence-ai-processor-chip-icon-symbol-for-graphic-design-logo-web-site-social-media-png.png"
          src="https://static.vecteezy.com/system/resources/previews/007/225/199/non_2x/robot-chat-bot-concept-illustration-vector.jpg"
          alt="Logo TuRips"
          className="img-fluid mx-auto mb-4"
          style={{ width: "140px" }}
        />
        <h1 className="text-dark mb-4" style={{ color:"#003F88", fontSize: "2.5rem", fontWeight: "600" }}>
          Bienvenido a Agent IA
        </h1>
        <p className="text-muted" style={{ fontSize: "1.2rem" }}>
          Sincroniza tus mensajes, domina tu agenda
        </p>
      </div>
    </div>
  );
}

export default Inicio;
